export default __webpack_public_path__ + "static/media/jg.950260c0.jpg";